export default __webpack_public_path__ + "static/storyheader-7b006dd14f53a736ff084a66ecf21faa.png";